<template>
    <div class="login dark-form">
        <div class="dark-form__inner">
            <h1 class="dark-form__title h1">
                LOOP.Linklist
            </h1>
            <transition name="slide-down">
                <div class="dark-form__error" v-if="submitError">
                    We didn't recognize that username and password. Please try
                    again.
                </div>
            </transition>
            <el-form
                class="form dark-form__form"
                ref="form"
                :model="formData"
                :rules="validationRules"
            >
                <el-form-item
                    label="E-Mail"
                    class="space-bottom--medium"
                    prop="email"
                >
                    <el-input
                        v-model="formData.email"
                        @input="touchForm"
                        type="email"
                        class="dark"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="Password"
                    class="space-bottom"
                    prop="password"
                >
                    <el-input
                        v-model="formData.password"
                        @input="touchForm"
                        type="password"
                        class="dark"
                    ></el-input>
                </el-form-item>
                <div class="login__bottom">
                    <el-form-item>
                        <Button
                            size="big"
                            @click="submitForm"
                            type="white-border"
                            >Login</Button
                        >
                    </el-form-item>
                    <div class="login__forgot-password">
                        <router-link
                            :to="{ name: 'Forgot Password' }"
                            class="login__forgot-password__link"
                            >Forgot password</router-link
                        >
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import Button from '@/components/Button.vue';
import * as api from '@/api';
import {
    clearUser,
    storeUser,
    clearOrganisation,
} from '@/utils/authentication.js';

export default {
    components: {
        Button,
    },
    data() {
        return {
            formTouched: false,
            submitError: false,
            formData: {
                email: '',
                password: '',
            },
            validationRules: {
                email: [
                    {
                        required: true,
                        message: 'Please enter your e-mail address',
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: 'Please input a valid email address.',
                        trigger: ['blur', 'change'],
                    },
                ],
                password: [
                    {
                        required: true,
                        message: 'Please enter your password',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    mounted() {
        clearUser();
        clearOrganisation();
    },
    methods: {
        async sendForm() {
            try {
                const loginResponse = await api.auth.login(
                    this.formData.email,
                    this.formData.password,
                );
                clearUser();
                clearOrganisation();
                storeUser(loginResponse.data.data);
                const userResponse = await api.user.me();
                console.log(userResponse);
                storeUser(userResponse.data.data);

                // load organisation after successfull login
                this.$store.dispatch(
                    'loadOrganisation',
                    userResponse.data.data.organisation.data.slug,
                );

                this.$router.push({ name: 'Organisation' });
            } catch (error) {
                this.submitError = true;
            }
        },
        touchForm() {
            this.formTouched = true;
        },
        submitForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.formTouched = false;
                    this.sendForm();
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.login {
    &__bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        @include mq(tablet) {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }

    &__forgot-password {
        margin-top: 30px;

        @include mq(tablet) {
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        &__link {
            font-size: 11px;
            text-transform: uppercase;
            color: $medium-grey;
            text-align: right;
            display: block;
            font-weight: $font-weight-bold;
            letter-spacing: 0.15em;
            transition: color 200ms $ease-out-cubic;

            .no-touch &:hover {
                color: white;
            }
        }
    }
}
</style>
